import React from 'react';
import { Box, Typography } from '@mui/material';

const HowItWorks = () => (
  <Box
    id="howitworks"
    sx={{
      width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', gap: '80px',
    }}
  >
    <Box sx={{ width: { xs: '100%', sm: '31%' } }}>
      <Typography sx={{
        background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: '30px', fontWeight: '600', lineHeight: '40px',
      }}
      >
        HOW WE DO IT
      </Typography>
    </Box>
    <Box sx={{
      width: { xs: '100%', sm: '69%' }, display: 'flex', flexDirection: 'column', justifyContent: { xs: 'space-between', sm: 'center' }, alignItems: 'center', gap: '40px',
    }}
    >
      <Box sx={{
        width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: { xs: 'start', sm: 'center' }, gap: '8px',
      }}
      >
        <Box className="first-column" sx={{ width: { xs: '70%', sm: '30%' } }}>
          <Box sx={{ width: '15%' }}>
            <hr style={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', height: '2px', border: 'none' }} />
          </Box>
          <Box>
            <Typography sx={{
              color: '#fff', fontSize: '21px', fontWeight: '500', lineHeight: '30px',
            }}
            >
              Live, group classes
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '60%' }}>
          <Typography sx={{ color: '#81AFDD', lineHeight: 'auto' }}>We believe that kids learn faster when in a small team. Our live, online classes offer children the opportunity to get creative and solve problems as part of a team. Not only will your child walk away with a new skill like coding, editing, or playing chess, but they will learn time management, problem-solving and teamwork.</Typography>
        </Box>
      </Box>
      <Box sx={{
        width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: { xs: 'start', sm: 'center' }, gap: '8px',
      }}
      >
        <Box className="first-column" sx={{ width: { xs: '70%', sm: '30%' } }}>
          <Box sx={{ width: '15%' }}>
            <hr style={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', height: '2px', border: 'none' }} />
          </Box>
          <Box>
            <Typography sx={{
              color: '#fff', fontSize: '21px', fontWeight: '500', lineHeight: '30px',
            }}
            >
              The Good Kind Of Screen Time
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '60%' }}>
          <Typography sx={{ color: '#81AFDD', lineHeight: 'auto' }}>Kids participate in live online lessons, interacting in real-time with an experienced teacher and a small group of students. They can ask questions and get immediate answers within the framework of the course. Together we create cool apps and games while mastering coding and digital art.</Typography>
        </Box>
      </Box>
      <Box sx={{
        width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: { xs: 'start', sm: 'center' }, gap: '8px',
      }}
      >
        <Box className="first-column" sx={{ width: { xs: '70%', sm: '30%' } }}>
          <Box sx={{ width: '15%' }}>
            <hr style={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', height: '2px', border: 'none' }} />
          </Box>
          <Box>
            <Typography sx={{
              color: '#fff', fontSize: '21px', fontWeight: '500', lineHeight: '30px',
            }}
            >
              Additional Weekly Practice Sessions
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '60%' }}>
          <Typography sx={{ color: '#81AFDD', lineHeight: 'auto' }}>In addition to the 1-hour lesson every week, students are invited to join a weekly practice hour with a teacher. Kids access practice sessions through our online learning environment: they can ask questions, raise topics they would like to know more about, and receive personal attention from the teacher.</Typography>
        </Box>
      </Box>
      <Box sx={{
        width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: { xs: 'start', sm: 'center' }, gap: '8px',
      }}
      >
        <Box className="first-column" sx={{ width: { xs: '70%', sm: '30%' } }}>
          <Box sx={{ width: '15%' }}>
            <hr style={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', height: '2px', border: 'none' }} />
          </Box>
          <Box>
            <Typography sx={{
              color: '#fff', fontSize: '21px', fontWeight: '500', lineHeight: '30px',
            }}
            >
              24/7 Learning Community
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '60%' }}>
          <Typography sx={{ color: '#81AFDD', lineHeight: 'auto' }}>Like the internet itself, our learning community is always open. Students can write questions, thoughts and ideas on the community forum and get a quick response from teachers and friends. The learning community, which is managed by the teacher, allows kids to expand their knowledge outside of class hours.</Typography>
        </Box>
      </Box>
    </Box>
  </Box>
);

export default HowItWorks;
